import React from 'react';
import { Link } from 'react-router-dom';
import { caseDetailPath } from '../../utils/courtCases';

const CaseReferenceLink = ({ caseReference, caseId, className = '' }) => {
  if (!caseReference) {
    return <span className={`text-legal-400 ${className}`.trim()}>—</span>;
  }

  const path = caseDetailPath(caseId || caseReference);

  return (
    <Link
      to={path}
      className={`text-court-600 hover:text-court-800 hover:underline font-medium ${className}`.trim()}
      onClick={(e) => e.stopPropagation()}
    >
      {caseReference}
    </Link>
  );
};

export default CaseReferenceLink;
